export default __webpack_public_path__ + "static/media/AXM-PM-A11-G01.aa16872b.jpg";